export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.287 2.119a3.821 3.821 0 016.475 2.117 3.82 3.82 0 11-2.483 7.089l-5.954 5.954a3.82 3.82 0 11-7.089 2.483 3.82 3.82 0 112.483-7.089l5.955-5.954a3.821 3.821 0 01.613-4.6zm3.99 1.414A1.821 1.821 0 0014.7 6.107a1 1 0 010 1.414l-7.18 7.18a1 1 0 01-1.414 0 1.82 1.82 0 10-1.029 3.09 1 1 0 011.13 1.13 1.821 1.821 0 103.09-1.03 1 1 0 010-1.413l7.18-7.18.075-.069c.393-.32.973-.297 1.34.07a1.82 1.82 0 101.029-3.09 1 1 0 01-1.131-1.131 1.817 1.817 0 00-.515-1.545z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};